<template>
    <div id="share">
        <a href="#" class="btn btn-small btn-create" v-on:click.stop.prevent="openModal('share-modal')" v-if="post.can.edit">
            <i class="icon ion-md-share"></i>
        </a>

        <div class="modal micromodal-slide" id="share-modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-share-title">
                    <div class="modal__content" id="modal-share-content">
                        <h3>Share this post publicly</h3>
                        <p>You can generate a link by clicking the button below to allow people outside of this account to view this post.</p>
                        <div class="form">
                            <div class="form__group">
                                <label class="form__label" for="link_expires">Set an expiry date for the link</label>
                                <div class="select">
                                    <select id="link_expires" name="link_expires" class="form__control" v-model="link_expires">
                                        <option value="1">Tomorrow</option>
                                        <option value="7">In one week</option>
                                        <option value="14">In two weeks</option>
                                        <option value="30">In one month</option>
                                        <option value="365">In one year</option>
                                        <option value="0">Never</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div v-if="shares.length !== 0">
                            <h4>Share links that already exist</h4>

                            <ul class="shares">
                                <li v-for="share in shares">
                                    <div class="info">  
                                        <avatar :user="share.user" :key="share.id"></avatar>
                                        <div class="url">
                                            <input readonly="" size="45" :value="protocol + '//' + host + '/public/' + post.slug + '/' + share.token">
                                            Link expires: {{share.expiry_date}}
                                        </div>
                                        <a href="#" v-on:click.stop.prevent="copyToClipboard(protocol + '//' + host + '/public/' + post.slug + '/' + share.token)">Copy link</a>
                                    </div>
                                    <div class="delete">
                                        <button class="btn btn-small btn-danger" v-on:click.stop.prevent="deleteShare(share.id)">
                                            <i class="icon ion-md-trash"></i>
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <footer class="modal__footer">
                        <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                        <button class="btn btn-primary" v-on:click.stop.prevent="saveShare">Generate sharing link</button>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';

    export default {
        props: ['post'],
        data() {
            return {
                host: window.location.hostname,
                protocol: window.location.protocol,
                link_expires: 14,
                shares: []
            }
        },
        mounted() {
            if(this.post.id){
                this.fetchShares();
            }
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            fetchShares(){
                let url = '/api/groups/' + this.post.group.slug + '/posts/' + this.post.slug + '/share';
                axios.get(url).then((response) => {
                    this.shares = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
            saveShare(){
                let url = '/api/groups/' + this.post.group.slug + '/posts/' + this.post.slug + '/share';
                axios.post(url, {link_expires: this.link_expires}).then((response) => {
                    this.shares.push(response.data);
                }, (response) => {
                    this.error = response;
                });
            },
            copyToClipboard(str) {
                const el = document.createElement('textarea');
                el.value = str;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            },
            deleteShare(share_id){
                let url = '/api/groups/' + this.post.group.slug + '/posts/' + this.post.slug + '/share/' + share_id;
                axios.delete(url).then((response) => {
                    this.fetchShares();
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>

<style lang="scss">
    #share{
        display: inline-block;
        margin-right: 10px;

        ul.shares{
            list-style: none;
            margin: 0;
            padding: 0;
            li{
                border-bottom: 1px solid #e0e5ea;
                padding: 10px 5px;

                .info{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .url{
                        width: 350px;
                        overflow: hidden;
                        border: 1px solid #e0e5ea;
                        border-radius: 2px;
                        padding: 5px 10px;
                        margin: 0 10px;

                        input{
                            outline: none;
                            border: 0;
                        }
                    }
                }

                .delete{
                    display: flex;
                    justify-content: flex-end;

                    button{
                        margin: 0;
                    }
                }
            }
        }
    }

    #share-modal{
        h4{
            font-size: 16px;
        }
    }
</style>